<template>
  <div class="manage-job wrapper">
    <proTitle></proTitle>
    <!-- 打卡数据 -->
    <ul class="job-data flex-layout">
      <li v-for="(item, index) in manageData" :key="index" class="data-item flex-align-between">
        <div>
          <span>{{ item.name }}</span>
          <br>
          <strong>{{ item.count }}</strong>
        </div>
        <img :src="item.icon" alt="">
      </li>
    </ul>
    <el-tabs v-if="isExpertRole" v-model="category" class="job-tabs" @tab-click="onTabChange">
      <el-tab-pane name="created">
        <span slot="label">我创建的<span class="tab-count">{{ createdCount }}</span></span>
      </el-tab-pane>
      <el-tab-pane name="assigned">
        <span slot="label">待我批改<span class="tab-count">{{ assignedCount }}</span></span>
      </el-tab-pane>
    </el-tabs>
    <div class="assign-hint" v-if="isAssignedTab">
      以下为<strong>管理员分配给您</strong>的批改任务：仅展示分配范围内的作业与应提交人，不包含您自己创建的作业主题。
    </div>
    <!-- 工具栏 -->
    <el-form :inline="true" class="demo-form-inline">
      <div class="formInline-right flex-layout">
        <div class="formInline-right-item">
          <i class="el-icon-data-line"></i>
          <span class="csp" @click="$router.push('/job/data')">学员整体数据</span>
        </div>
        <div class="formInline-right-item" v-if="canOperateTheme">
          <i class="el-icon-circle-plus-outline"></i>
          <span class="csp" @click="createTheme">创建作业主题</span>
        </div>
      </div>
    </el-form>
    <!-- 表格 -->
    <div class="mid-bot">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" prop="id" label="序号" width="100px"></el-table-column>
        <el-table-column align="center" prop="themeName" label="作业主题名称" min-width="220px">
          <template slot-scope="scope">
            <span>{{ scope.row.themeName }}</span>
            <el-tag v-if="isAssignedTab && scope.row.assignSource" size="mini" type="primary" class="assign-source">
              {{ scope.row.assignSource }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="themeType" label="主题类型"></el-table-column>
        <el-table-column align="center" prop="questCount" label="作业总数量"></el-table-column>
        <el-table-column align="center" prop="questCommitCount" label="作业提交数量"></el-table-column>
        <el-table-column align="center" prop="mean" label="平均提交比例"></el-table-column>
        <el-table-column align="center" prop="type" label="操作" width="140px" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" style="margin-left:10px" @click="goDetail(scope.row)">查看
            </el-button>
            <el-button v-if="canOperateTheme" type="text" @click="goEdit(scope.row.id)" size="small">编辑</el-button>
            <el-button v-if="canOperateTheme" type="text" size="small" @click="removeTheme(scope.row.id)">删除</el-button>
            <el-button type="text" size="small" style="margin-left:10px" @click="downLoad(scope.row.id)">打包下载
            </el-button>
            <el-button type="text" size="small" style="margin-left:10px" @click="subTotal(scope.row.id)">提交情况统计
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="pages.total > 0" :total="pages.total" :page.sync="pages.currentPage"
        :limit.sync="pages.pageSize" :pageSizes="[8, 16, 24]" @pagination="handlePageChange">
      </pagination>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
import {
  mapState
} from "vuex";

export default {
  data() {
    return {
      // activeName: "",
      category: 'created',
      createdCount: 0,
      assignedCount: 0,
      tableData: [],
      manageData: [{
        title: 'themeCount',
        name: '作业主题数',
        count: '0',
        icon: require("@/assets/images/teach/theme.png"),
      },
      {
        title: 'workCount',
        name: '作业总数量',
        count: '0',
        icon: require("@/assets/images/teach/job.png")
      },
      {
        title: 'testCount',
        name: '测试总数量',
        count: '0',
        icon: require("@/assets/images/teach/test.png")
      },
      {
        title: 'questCount',
        name: '问卷总数量',
        count: '0',
        icon: require("@/assets/images/teach/quest.png")
      },
      {
        title: 'commitCount',
        name: '作业提交数量',
        count: '0',
        icon: require("@/assets/images/teach/issue.png")
      }
      ],
      pages: { //分页
        currentPage: 1,
        pageSize: 8,
        total: 0,
      },
      hideUsertype: {
        238: [14549, 14550, 14551, 14552, 14553, 14554, 14555, 14556, 14557],
        248: [8855, 8856, 8857],
        251: [10074, 10075, 10076, 10077, 10078, 10079, 10080, 10081, 10082, 10083, 10084, 10085, 10086, 10087,
          10088, 10089, 10090, 10091, 10092, 10093, 10094, 10095, 10096, 10097, 10098, 10099, 10100, 10101, 10102,
          10103, 10104, 10105, 10106, 10107, 10108, 10109, 10110, 10111, 10112, 10113, 10114, 10115, 10116, 10117,
          10118, 10119, 10120, 10121, 10122, 10123, 10124, 10125, 10126, 10127, 10128, 10129, 10130, 10131, 10132,
          10133, 10134, 10135, 10136, 10137, 10138, 10139, 10140, 10141, 10142, 10143, 10144, 10145, 10146, 10147,
          10148, 10149, 10150, 10151, 10152, 10153, 10154, 10155, 10156, 10157, 10158, 10159, 10160, 10161, 10162,
          10163, 10164, 10165, 10166, 10167, 10168, 10169, 10170, 10171, 10172, 10173, 10174, 10175, 10176, 10177,
          10178, 10179, 10180, 10181, 10182, 10183, 10184, 10185, 10186, 10187, 10188],
      },
    };
  },
  computed: {
    ...mapState({
      userId: state => state.user.userInfo.id,
      activeName: state => state.user.currentProject.id,
      role: state => state.user.role
    }),
    isExpertRole() {
      return this.role === 'expert' || this.role === 'exports'
    },
    isAssignedTab() {
      return this.isExpertRole && this.category === 'assigned'
    },
    canOperateTheme() {
      if (this.isAssignedTab) return false
      const hideIds = this.hideUsertype[this.activeName]
      return !hideIds || hideIds.indexOf(this.userId) < 0
    }
  },
  watch: {
    '$store.state.user.currentProject.id': {
      handler(newVal, oldVal) {
        if (!newVal) return;
        this.pages.currentPage = 1;
        if (this.isExpertRole) this.refreshAssignedCount();
        this.getThemeList();
        this.getManageInfo();
      }
    }
  },
  methods: {
    // 翻页
    handlePageChange(data) {
      this.pages.currentPage = data.pageIndex
      this.pages.pageSize = data.pageSize
      // console.log(this.pages);
      this.getThemeList();
    },
    // 获取统计数据
    async getManageInfo(id) {
      let params = {
        secondId: this.activeName,
        userId: this.userId,
      };
      this.$Api.Form.getWorkManage(params)
        .then((value) => {
          if (this.isAssignedTab) return
          this.manageData.map(item => {
            item.count = value.data[item.title]
          })
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    onTabChange(tab) {
      if (tab && tab.name) this.category = tab.name
      this.pages.currentPage = 1;
      this.getThemeList();
      if (!this.isAssignedTab) {
        this.getManageInfo();
      }
    },
    formatThemeType(type) {
      const map = {
        1: '作业',
        2: '测试',
        3: '问卷',
        4: '普通话测试',
        5: '书法前测',
        6: '书法后测'
      }
      return map[type] || type || '作业'
    },
    formatMean(item) {
      if (
        item.questCommitCount == 0 ||
        item.userCount == 0 ||
        item.questCount == 0
      ) {
        return '0%'
      }
      return Math.round(
        (item.questCommitCount / (item.userCount * item.questCount)) * 100
      ) + '%'
    },
    getAssignSource(item) {
      const from = item.from || '管理员分配'
      let groups = item.groupNames
      if (Array.isArray(groups)) groups = groups.filter(Boolean).join('、')
      return groups ? (from + ' · ' + groups) : from
    },
    applyAssignedStats(list) {
      const rows = list || []
      const countMap = {
        themeCount: this.assignedCount,
        workCount: rows.reduce((s, r) => s + (Number(r.questCount) || 0), 0),
        commitCount: rows.reduce((s, r) => s + (Number(r.questCommitCount) || 0), 0)
      }
      this.manageData.forEach(item => {
        if (countMap[item.title] != null) item.count = countMap[item.title]
      })
    },
    unwrapThemePage(res) {
      const data = res && res.data
      if (Array.isArray(data)) return { list: data, total: data.length }
      if (data && Array.isArray(data.list)) {
        return {
          list: data.list,
          total: data.totalCount != null ? data.totalCount : (data.total || 0)
        }
      }
      return { list: [], total: 0 }
    },
    formatAssignedRows(list) {
      return (list || []).map(item => {
        const row = Object.assign({}, item)
        row.mean = this.formatMean(row)
        row.themeType = this.formatThemeType(row.themeType)
        row.assignSource = this.getAssignSource(row)
        return row
      })
    },
    async refreshAssignedCount() {
      const res = await this.$Api.Form.getThemeListByAssign({
        projectId: this.activeName,
        page: 1,
        limit: 1
      }).catch(() => null)
      if (res && res.code == 200) {
        this.assignedCount = this.unwrapThemePage(res).total
      }
    },
    async loadAssignedList() {
      const res = await this.$Api.Form.getThemeListByAssign({
        page: this.pages.currentPage,
        limit: this.pages.pageSize,
        projectId: this.activeName
      }).catch(() => null)
      if (!res || res.code != 200) {
        this.tableData = []
        this.pages.total = 0
        if (res && res.msg) this.$message.error(res.msg)
        return
      }
      const page = this.unwrapThemePage(res)
      this.pages.total = page.total
      this.assignedCount = page.total
      this.tableData = this.formatAssignedRows(page.list)
      this.applyAssignedStats(this.tableData)
    },
    // 创建作业主题
    createTheme() {
      this.$router.push({
        path: "/createTheme_copy",
        query: {
          projectId: this.activeName,
          createId: this.userId,
          breadNumber: 4
        },
      });
    },
    // 去编辑
    goEdit(scope) {
      this.$router.push({
        path: "/createTheme_copy",
        query: {
          id: scope, //作业主题id
          projectId: this.activeName, //二级项目id
          createId: this.userId, //主题创建者id
          edit: true, //是否是点击编辑按钮进入
          breadNumber: 4
        },
      });
    },
    // 删除作业主题
    removeTheme(id) {
      console.log("删除的作业主题id--", id);
      this.$confirm("是否删除该作业主题?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          this.$Api.Form.deleteTheme(id)
            .then((res) => {
              console.log(res);
              //更新作业主题列表
              this.getThemeList();
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          this.$message({
            type: "info",
            message: "取消成功",
          });
        });
    },
    // 查看详情。待我批改入口才带 assignScope，原列表不带
    goDetail(row) {
      const id = row && row.id != null ? row.id : row
      const query = {
        projectId: this.activeName,
        themeId: id,
        createId: this.userId,
        breadNumber: 4,
      }
      if (this.isAssignedTab && row && row.id != null) {
        query.assignScope = 1
        query.from = row.from || '管理员分配'
        let groups = row.groupNames
        if (Array.isArray(groups)) groups = groups.filter(Boolean).join('、')
        if (groups) query.groupNames = groups
      }
      this.$router.push({
        path: "/workManage",
        query,
      });
    },
    // 获取作业主题列表
    async getThemeList() {
      if (this.isAssignedTab) {
        await this.loadAssignedList()
        return
      }
      let params = {
        page: this.pages.currentPage,
        limit: this.pages.pageSize,
        projectId: this.activeName,
      };
      this.$Api.Form.getThemeList(params)
        .then((res) => {
          this.pages.total = res.data.totalCount;
          this.createdCount = res.data.totalCount;
          res.data.list.map((item) => {
            item.mean = this.formatMean(item)
            item.themeType = this.formatThemeType(item.themeType)
          });
          this.tableData = res.data.list;
        })
        .catch((err) => console.log(err));
    },
    // 打包下载
    downLoad(themeId) {
      window.location.href =`${axios.defaults.baseURL}/quest/front/answer/exportZip/theme/export?themeId=${themeId}`
    },
    // 提交情况统计
    subTotal(themeId) {
      window.location.href =`${axios.defaults.baseURL}/quest/front/answer/answerStatus/export?themeId=${themeId}`
    }
  },
  mounted() {
    if (this.isExpertRole) this.refreshAssignedCount();
    this.getThemeList();
    this.getManageInfo();
  }
};
</script>

<style lang="less" scoped>
@import "../less/table.less";

.job-tabs {
  margin-top: 16px;

  /deep/ .el-tabs__content {
    display: none;
  }

  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }

  /deep/ .el-tabs__item {
    height: 44px;
    line-height: 44px;
    font-size: 14px;
  }
}

.tab-count {
  display: inline-block;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  padding: 0 5px;
  margin-left: 6px;
  border-radius: 9px;
  background: #f0f2f5;
  color: #999;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  vertical-align: 1px;
}

/deep/ .el-tabs__item.is-active .tab-count {
  background: #ecf5ff;
  color: #409EFF;
}

.assign-hint {
  margin-top: 12px;
  padding: 10px 14px;
  border-radius: 6px;
  background: #f0f7ff;
  border: 1px solid #d6e8ff;
  color: #666;
  font-size: 13px;
  line-height: 1.6;

  strong {
    color: #409EFF;
    font-weight: 600;
  }
}

.assign-source {
  margin-left: 6px;
  vertical-align: middle;
}

.job-data {
  margin-top: 16px;

  .data-item {
    width: 149px;
    margin-right: 16px;
    border: 1px solid #E7E7E7;
    border-radius: 5px;
    padding: 11px 5px 11px 8px;
    font-size: 12px;

    &:last-child {
      margin-right: 0;
    }

    img {
      width: 32px;
      background-color: rgba(0, 80, 255, .1);
      border-radius: 50%;
    }

    &:nth-child(2) img {
      background-color: rgba(253, 178, 90, .1);
    }

    &:nth-child(3) img {
      background-color: rgba(157, 119, 251, .1);
    }

    &:nth-child(4) img {
      background-color: rgba(74, 210, 255, .1);
    }

    &:nth-child(5) img {
      background-color: rgba(254, 128, 60, .1);
    }


    strong {
      font-size: 14px;
    }
  }
}

.formInline-right {
  text-align: right;
  margin-top: 22px;
  justify-content: flex-end;

  .formInline-right-item {
    margin-right: 10px;
  }

  i {
    font-size: 19px;
    vertical-align: -2px;
  }

  .el-icon-data-line+span {
    padding-left: 7px;
  }
}

.mid-bot {
  margin-top: 15px;
}

@media screen and (min-width: 1250px) {
  .job-data {
    margin-top: 20px;

    .data-item {
      padding: 16px 11px;
      font-size: 14px;

      img {
        width: 37px;
      }

      strong {
        font-size: 18px;
      }
    }
  }

  .formInline-right {
    margin-top: 30px;
  }

}
</style>